/* eslint-disable global-require */

module.exports = {
	name: "Factio", // Business name
	project: null, // Project permalink
	pack: "factio",
	version: require("../../../package.json").version,
	globalSearch: {
		app: "empresas",
		text: ["EmpresaNombreComercial", "EmpresaNombre"],
		onSelect: (router, id) => {
			router.push({ name: "empresa", params: { id } });
		},
	},
	chat: false,
	config: "_config", // Name of project configuration route
	keepalive: [],
	sentry: "", // Sentry DSN Url
	paths: {
		api: "https://gestios.es/api/1",
		api_dev:
			process.env.VUE_APP_ENVIRONMENT === "production"
				? "https://gestios.dev/api/1"
				: "https://gestios.dev/api/1",
		lambda:
			process.env.VUE_APP_ENVIRONMENT === "production"
				? "https://factio.gestios.app/api"
				: "http://localhost:3000/api",
	},
};
